import Tooltip from '@mui/material/Tooltip'
import React from 'react'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Old/Colors'

const WarningBadge = ({ value, tooltip }) => {
  if (value === null) return ''
  let iconColor = value ? Colors.collarMinorError : Colors.borderGray

  return (
    <div>
      {tooltip ? (
        <Tooltip title={tooltip} aria-label={tooltip}>
          <span>
            <Icon size="large" name="warning" style={{ color: iconColor }} />
          </span>
        </Tooltip>
      ) : (
        <Icon size="large" name="warning" style={{ color: iconColor }} />
      )}
    </div>
  )
}

export default WarningBadge
